import { useAppReducer } from '@components/app/AppReducer';
import { getDefaultLocaleForLanguage } from '../../locales';

/**
 *  Use this hook to extract the locale value to pass to the data layer queries as an optional param.
 *  Not to be used for localization purposes
 */
const useLocaleForQueries = (): string | null => {
  const {
    state: { locale }
  } = useAppReducer();

  // extract the default locale values from the current locale to pass as optional param
  return getDefaultLocaleForLanguage(locale);
};
export default useLocaleForQueries;
